import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { haptic } from '../../utils/fx'
import './QuantityInput.scss'

type Props = {
  setQuantity: (quantity: number | ((prev: number) => number)) => void
  quantity: number
  cartItem?: boolean
  size?: 'sm' | 'md' | 'lg'
  tone?: 'light' | 'primary'
}

const c = 'quantity-input'

const QuantityInput = ({
  setQuantity,
  quantity,
  cartItem,
  size = 'md',
  tone = 'light',
}: Props) => {
  function increment(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation()
    haptic()
    setQuantity((prev: number) => (e.shiftKey ? prev + 10 : prev + 1))
  }

  function decrement(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation()
    const min = cartItem ? 0 : 1
    if (quantity <= min) {
      return
    }
    haptic()
    setQuantity((prev: number) => Math.max(min, prev - (e.shiftKey ? 10 : 1)))
  }

  const willRemove = cartItem && quantity <= 1

  return (
    <div className={`${c} ${c}--${size} ${c}--${tone}`}>
      <button
        type='button'
        className={`${c}__action${willRemove ? ' is-remove' : ''}`}
        onClick={decrement}
        disabled={!cartItem && quantity <= 1}
        aria-label='-'
      >
        <FontAwesomeIcon icon={willRemove ? faTrashCan : faMinus} />
      </button>
      <div className={`${c}__value`}>
        <span key={quantity}>{quantity}</span>
      </div>
      <button
        type='button'
        className={`${c}__action`}
        onClick={increment}
        aria-label='+'
      >
        <FontAwesomeIcon icon={faPlus} />
      </button>
    </div>
  )
}

export default QuantityInput
